<div class="name-territory">
    <!-- Left Panel -->
    <div class="name-territory__panel">
        <!-- Territory Name Section -->
        <div class="name-territory__section">
            <h2 class="name-territory__section-title">Territory Name</h2>
            <p class="name-territory__section-subtitle">
                Type in the name for the territory you have drawn
            </p>
            <div class="name-territory__input-container">
                <input
                    class="name-territory__input"
                    [class.error]="getErrorMessage().trim()"
                    [formControl]="territoryNameControl" />
                @if (getErrorMessage().trim()) {
                    <span class="name-territory__input-error">{{ getErrorMessage() }}</span>
                }
            </div>
        </div>

        <!-- Territory Details Section -->
        <div class="name-territory__section">
            <h2 class="name-territory__section-title">Territory Details</h2>
            <div class="name-territory__details-grid">
                @for (accordion of nameTerritoryLayout.accordions; track accordion.index) {
                    <ntv-accordion class="name-territory__accordion" size="sm" variant="bordered">
                        <div slot="header">{{ accordion.header }}</div>
                        <div slot="body" class="name-territory__coords">
                            @for (coord of territoryCoordinates(); track $index) {
                                <p class="name-territory__detail-value">
                                    {{ coord[accordion.index] }}
                                </p>
                            }
                        </div>
                    </ntv-accordion>
                }
                @for (detail of nameTerritoryLayout.details; track detail.field) {
                    <div class="name-territory__detail">
                        <span class="name-territory__detail-label">{{ detail.label }}</span>
                        <span class="name-territory__detail-value">
                            @if (detail.format === 'date') {
                                {{ $any(getDetailValue(detail.field)) | date: 'MMMM d, yyyy' }}
                            } @else if (detail.format === 'fixed2') {
                                {{ $any(getDetailValue(detail.field)).toFixed(2)
                                }}{{ detail.suffix ?? '' }}
                            } @else {
                                {{ getDetailValue(detail.field) }}{{ detail.suffix ?? '' }}
                            }
                        </span>
                    </div>
                }
            </div>
        </div>

        <!-- Info Card -->
        <div class="name-territory__info-card">
            <div class="name-territory__info-header">
                <div class="name-territory__info-icon-wrapper">
                    <svg class="name-territory__info-icon">
                        <use href="assets/icons/icons-sprite.svg#shield"></use>
                    </svg>
                </div>
                <h3 class="name-territory__info-title">You're Almost Done!</h3>
            </div>
            <p class="name-territory__info-text">
                This is your territory — the area where you can request host installations in the
                future. Our team will help you through the setup process to make sure everything
                runs smoothly.
            </p>
            <p class="name-territory__info-text">
                Give your territory a name and review the details before finishing up!
            </p>
            <div class="name-territory__info-note">
                <span
                    >Need to combine your territory with someone else's? Just send a merge request
                    to the admin.</span
                >
            </div>
        </div>
    </div>

    <!-- Right Panel: Map -->
    <div class="name-territory__map">
        <app-territory-map
            variant="view"
            [autoCenter]="false"
            [coordinates]="territoryCoordinates()"
            [showControls]="false"></app-territory-map>
    </div>
</div>
